window.addEventListener('load', (event) => {
    const $productSlider = document.getElementById('product-slider');

    const mobileBreakpoint = 753;
    let lastKnownWidth = 0;
    let ticking = false;
    let mobileDevice = isMobileDevice(window.innerWidth);
    let productSwiper;

    window.addEventListener('resize', function(e) {
        lastKnownWidth = window.innerWidth;

        if (!ticking) {
            window.requestAnimationFrame(function() {
                handleResize(lastKnownWidth);
                ticking = false;
            });

            ticking = true;
        }
    });

    function handleResize(width) {

        if (isMobileDevice(width) && !mobileDevice) {
            mobileDevice = true;
            initProductSlider();
        } else if (!isMobileDevice(width) && mobileDevice) {
            mobileDevice = false;
            destroyProductSlider();
        }
    }

    function isMobileDevice(deviceWidth) {
        return deviceWidth <= 753;
    }

    function initProductSlider() {

        if (isMobileDevice(window.innerWidth)) {
            $productSlider.firstElementChild.classList.remove('md:flex-col');

            productSwiper = new Swiper($productSlider, {
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            });
        }
    }

    function destroyProductSlider() {
        productSwiper.destroy();

        $productSlider.firstElementChild.classList.add('md:flex-col');
    }

    initProductSlider();
    handleResize(window.innerWidth);
});
